import React from 'react'
import { createRoot } from 'react-dom/client'
import { parseLocale } from '@gameforge/loca'
import { Event } from '../types'
import { UI } from './UI'
import './types'

type ShowMessage = {
  type: 'show'
  origin: string
  payload: {
    gameId: string
    gameEnvironmentId: string
    gameImageUrl?: string
    locale?: string
  }
}

const getLocale = (defaultLocale?: string) =>
  parseLocale(defaultLocale || window.navigator.language || 'en-GB').short

window.addEventListener('message', (e: MessageEvent<ShowMessage>) => {
  const { payload, type } = e.data
  const { origin } = e

  if (type !== 'show') return

  const app = document.getElementById('root')
  if (!app) return

  const root = createRoot(app)

  const close = (success?: boolean, redirect?: string) => {
    root.unmount()

    parent.postMessage(
      { type: success ? 'success' : 'close', redirect },
      origin
    )
  }

  const events = [
    'GFLandingpageConnectOpen',
    'GFSessionExist',
    'GFUserSignUp',
    'GFUserSignIn',
    'GFUserSignOut',
    'GFGameAccountCreate',
    'GFGameAccountExist'
  ] as Event[]

  events.forEach((eventType: string) =>
    window.addEventListener(eventType, e => {
      const detail = (e as CustomEvent<unknown>).detail

      parent.postMessage({ type: 'event', eventType, detail }, origin)
    })
  )

  const props = {
    ...payload,
    close,
    locale: getLocale(payload.locale)
  }

  root.render(React.createElement(UI, props))
})
